import React, { memo } from 'react';

import { SectionLabelStyled } from '../../styled/styled';
import type { Information } from '../types';
import { InformationWrapper } from './styled';

type Props = {
  title: string;
  information: Information[];
};

const TableItem = ({ title, information }: Props): JSX.Element => {
  return (
    <div>
      <SectionLabelStyled>{title}</SectionLabelStyled>
      {information.map((item, index) => (
        <InformationWrapper key={index}>{item}</InformationWrapper>
      ))}
    </div>
  );
};

export default memo(TableItem);
